import React from 'react';

import { IconProps } from './types';

export const HighPriorityIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M15.9998 1.99873C15.4686 1.99742 14.936 2.14196 14.4673 2.43102V2.43362C9.51026 5.48831 5.48812 9.50914 2.43343 14.4675C1.85401 15.4063 1.8527 16.5938 2.43083 17.5326H2.43343C5.48812 22.4896 9.51026 26.5131 14.4673 29.5677C15.4061 30.1485 16.5936 30.1472 17.5324 29.5677C22.4894 26.5131 26.5116 22.4909 29.5662 17.5352C30.147 16.5951 30.147 15.4063 29.5662 14.4675C26.5103 9.51045 22.4894 5.48831 17.5324 2.43362C17.0636 2.14326 16.5311 1.99873 15.9998 1.99873ZM15.9998 4.00133C16.1704 4.00263 16.3397 4.0469 16.4829 4.13414C21.1834 7.03258 24.966 10.8164 27.8644 15.517C28.0415 15.8034 28.0428 16.1966 27.8644 16.4844C24.9673 21.1862 21.1834 24.9662 16.4829 27.8646C16.1952 28.0417 15.8006 28.0417 15.5155 27.8646C10.8136 24.9662 7.03239 21.1862 4.13395 16.4844C3.95687 16.1966 3.95817 15.8034 4.13395 15.517V15.5157C7.03239 10.8138 10.8136 7.03258 15.5155 4.13414C15.66 4.0456 15.8293 4.00133 15.9998 4.00133ZM15.9842 8.98571C15.4321 8.99482 14.992 9.44795 14.9998 10V17.767C14.9946 18.1276 15.1847 18.4636 15.4959 18.6459C15.8071 18.8269 16.1925 18.8269 16.5037 18.6459C16.8149 18.4636 17.005 18.1276 16.9998 17.767V10C17.0037 9.7292 16.8983 9.47008 16.7069 9.27868C16.5155 9.08727 16.255 8.9818 15.9842 8.98571ZM15.9998 20.2813C15.5493 20.2748 15.13 20.5117 14.9022 20.9011C14.6756 21.2904 14.6756 21.7722 14.9022 22.1615C15.13 22.5508 15.5493 22.7878 15.9998 22.7813C16.4504 22.7878 16.8696 22.5508 17.0975 22.1615C17.3241 21.7722 17.3241 21.2904 17.0975 20.9011C16.8696 20.5117 16.4504 20.2748 15.9998 20.2813Z"
          fill={color}
        />
      </svg>
    );
  },
);
